import { env } from '@edge/env'
import ReactGA from 'react-ga4'

const trackingCode = env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE

export const googleAnalyticsInitialize = (): void => {
    if (trackingCode) {
        ReactGA.initialize(trackingCode)
        // Not needed for GA-4 ?
        // ReactGA.pageview(window.location.pathname + window.location.search)
    }
}

export default googleAnalyticsInitialize
